<template>
    <el-dialog
        class="detail"
        :visible.sync="detailVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1000px"
        title="面试详情"
        v-loading="loading"
    >
        <div class="container">
            <div class="formCont">
                <el-row>
                    <el-col :span="12">
                        <div class="label">招聘岗位：</div>
                        <div class="content">{{ msg.recruitment_position }}</div>
                    </el-col>
                    <el-col :span="12">
                        <div class="label">面试时间：</div>
                        <div class="content">{{ msg.interview_time }}</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <div class="label">应聘者姓名：</div>
                        <div class="content">{{ msg.name }}</div>
                    </el-col>
                    <el-col :span="12">
                        <div class="label">应聘者手机号：</div>
                        <div class="content">{{ msg.phone }}</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <div class="label">面试官：</div>
                        <div class="content">{{ msg.interviewer_name }}</div>
                    </el-col>
                    <el-col :span="12">
                        <div class="label">邮箱：</div>
                        <div class="content">{{ msg.email }}</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <div class="label">简历文件：</div>
                        <div class="content link" @click="download(msg.file)">{{ file }}</div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button
                size="small"
                @click="detailVisible = false"
                >关闭</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import * as oaApi from "@/http/oaApi.js";
import { mapState } from "vuex";
export default {
    name: "interviewDetail",
    data() {
        return {
            loading: false,
            msg: {},
            previewList: [],
            showReview:false,
            file:"",
        };
    },
    watch: {
        detailVisible: {
            handler(newValue) {
                if (newValue) {
                    this.interview();
                }
            },
        },
    },
    props: {
        detailVisible: Boolean,
        tableItem: Object,
    },
    methods: {
        closeDialog() {
            this.$emit("update:detailVisible", false);
        },
        interview() {
            oaApi.interview({}, "get", this.tableItem.id).then((res) => {
                //console.log(res);
                if (res.code == 200) {
                    this.msg = res.data;
                    this.file = this.msg.file.split("/")[this.msg.file.split("/").length-1]
                }
            });
        },
        /**
         * 下载文件
         */
        download(url){
          window.open(url)
        }
    },
    computed: {
        ...mapState({
            wwwUrl: state => state.index.wwwUrl,
        }),
    },
    mounted() {},
};
</script>

<style lang="scss" scoped>

</style>